import { findParentItem } from './dataUtil';

export const findSelectedMenu = (menuList, pathname) => {
  let selectedTopMenu = null;
  let selectedMenu = null;

  if (pathname !== '/' && pathname.length > 1 && menuList.length > 0) {
    selectedMenu = menuList.find((e) => import.meta.env.VITE_PUBLIC_URL + e.programRoutePath === pathname);
    if (selectedMenu) {
      selectedTopMenu = findParentItem(
        menuList,
        selectedMenu.menuId,
        Infinity,
        'menuId',
        'parentId'
      );
    }
  }

  return {
    selectedTopMenu,
    selectedMenu,
  };
};

/**
 * find route path by menuId
 * @param {*} menuList 
 * @param {*} menuId 
 * @returns 
 */
export const findRoutePath = (menuList = [], menuId = '') => {
  if (menuList.length === 0) return '';

  let selectedMenu = menuList.find((x) => {
    return x.menuId === menuId;
  });

  return selectedMenu?.programRoutePath ?? '/';
};

/**
 * find top menu by menuId
 * @param {*} menuList 
 * @param {*} menuId 
 * @returns 
 */
export const findTopMenu = (menuList = [], menuId = '') => {
  if (!menuList.length) return null;

  let selectedItem = menuList?.find((x) => x.menuId === menuId);

  if (!selectedItem) return '';

  if (selectedItem?.parentId) {
    return findTopMenu(menuList, selectedItem.parentId);
  } else {
    return selectedItem;
  }
};
